import { Alert, Button, CircularProgress, Dialog, DialogTitle, DialogContent } from "@mui/material";
import { useState } from "react";
import { DriveFiles } from "./DriveFiles";
import customersService from "services/admin/customersService";
import sheetsService from "services/admin/sheetsService";
import { toast } from "react-toastify";

const CustomersImportFromGoogleSheetV2 = () => {
  const [isDriveFileDialogOpen, setIsDriveFileDialogOpen] = useState(false);

  const selectFile = async (fileID: string) => {
    console.log("selectFile", fileID);
    setIsDriveFileDialogOpen(false);
    try {
      const sheetContent = await customersService.importCustomersFromGoogleSheet(fileID);
      console.log("sheetContent", sheetContent.data);
      toast.success("Клиенты успешно загружены!");
    } catch (error) {
      console.error("error", error);
      toast.error("Ошибка при получении содержимого файла");
    }
  };

  return (
    <div>
      <h3 className="mb-4">Здесь вы можете загружать клиентов через Google Sheet файл.</h3>
      <Alert color="info" className="m-b-16">
        Перед загрузкой клиентов через Google Sheet убедитесь, что данные корректны, не содержат
        дубликатов и номера телефонов указаны для каждого клиента в международном формате без
        плюса(+), например для Казахстана: 77772001991. В случае наличия дублирующих записей система
        примет только первую запись.
      </Alert>
      <p className="mb-8">Пожалуйста, выберите файл, после нажмите на кнопку загрузить.</p>

      <Button type="button" variant="contained" onClick={() => setIsDriveFileDialogOpen(true)}>
        Выбрать файл
      </Button>

      <Dialog open={isDriveFileDialogOpen} onClose={() => setIsDriveFileDialogOpen(false)}>
        <DialogTitle>Выбрать файл</DialogTitle>
        <DialogContent>
          <DriveFiles onSelectFile={selectFile} />
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default CustomersImportFromGoogleSheetV2;
